import axios from "axios";
import { idText } from "typescript";
import { getToken, getUser } from "../Utils/Common";
import { getAPICall, postAPICall, postAPICall2, putAPICall, deleteAPICall, getWithParamsAPICall } from "./axiosMethodCalls";

//GET
export const getShowMenuManager = async (id) => {
    
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "menus/show/" + id,
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const getAllMenuManager = async () => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "menus/getAll"
        );
        return { data: response };
    } catch (error) {
        return { error: error.response };
    }
};

export const searchMenuManager = async (name) => {
    try {
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "menus/search", {
                term: name
            }
        );
        return { data: response };
    } catch (error) {
        return { error: error.response };
    }
};

//GET
export const getAllByCategoryMenuManager = async (category_id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "menus/category",
            {
                category_id: category_id,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

//GET
export const createMenuManager = async (data, packageDetails, fileList) => {
    try {
        var formData = new FormData();

        packageDetails?.map((data) => {
            formData.append("menu[]", data.value ? data.value: "")
            formData.append("menu_name[]", data.name ? data.name: "")
            formData.append("menu_qty[]", data.qty)
            formData.append("menu_unit[]", data.unit)
        })

        formData.append("file", fileList[0]?.originFileObj || "")
        
        if(data?.categories && data.is_modifier === "0"){
            data.categories.map((info) => {
              formData.append("categories[]", info.value);
            });
            data.modifiers.map((info) => {
              formData.append("modifiers[]", info);
            });
            formData.append("with_modifier", data.with_modifier);
        }
        formData.append("is_modifier", data.is_modifier);
        formData.append("item_code", data.item_code);
        formData.append("default_printer", data.default_printer);
        formData.append("takeout_price", data.takeout_price);
        // formData.append("categories[]", data.categories.value)
        formData.append("effective_date", data.effective_date)
        formData.append("is_addon", data.is_addon)
        // formData.append("frequency", data.frequency || '')
        // formData.append("qty", data.qty || '')
        formData.append("remarks", data.remarks)
        formData.append("reorder_point", data.reorder_point)
        // formData.append("reorder_qty", data.reorder_qty || '')
        formData.append("is_package", data.is_package)
        formData.append("is_dine_in", data.is_dine_in)
        formData.append("is_take_out", data.is_take_out)
        formData.append("is_delivery", data.is_delivery)
        formData.append("suspend_sale", data.suspend_sale)
        formData.append("quick_menu", data.quick_menu || 0)
        formData.append("sold_by_weight", data.sold_by_weight)
        formData.append("weight", data.weight)
        formData.append("open_price", data.open_price)
        formData.append("with_discount", data.with_discount)
        formData.append("is_addon", data.is_addon)
        formData.append("name", data.name)
        // formData.append("is_vatable", data.is_vatable)
        formData.append("price", data.price)
        formData.append("foodpanda_price", data.foodpanda_price)
        formData.append("grab_price", data.grab_price)
        formData.append("vat_in", data.price);
        formData.append("is_vatable", data.is_vatable ? "1" : "0");
        formData.append("vat_ex", data.vat_ex);
        formData.append("vat_component", data.vat_component);
        formData.append("other_charges", data.other_charges)
        formData.append("description", data.description)
        formData.append("requester", getUser())
        formData.append("token", getToken())
        
        const response = await postAPICall2(
            process.env.REACT_APP_LINK + "menus/create",
            formData 
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const updateMenuManager = async (data, packageDetails, fileList) => {
    try {
        // let data_arr = []
        // if(Array.isArray(data.new_obj)){
        //     data_arr = data.new_obj
        // }else{
        //     data_arr.push({...data.new_obj})
        // }
        var formData = new FormData();
        packageDetails?.map((data) => {
            formData.append("menu[]", data.value ? data.value: "")
            formData.append("menu_name[]", data.name ? data.name: "")
            formData.append("menu_qty[]", data.qty)
            formData.append("menu_unit[]", data.unit)
        })

        if (fileList[0]?.originFileObj) {
            formData.append("file", fileList[0].originFileObj);
        }        
     
        if(data?.categories && data.is_modifier === "0"){
            data?.categories.map((info) => {
              formData.append("categories[]", info.value);
            });
            data?.modifiers && data?.modifiers.map((info) => {
              formData.append("modifiers[]", info);
            });
            formData.append("with_modifier", data.with_modifier);
        }

        formData.append("is_modifier", data.is_modifier);
        formData.append("item_code", data.item_code);
        formData.append("default_printer", data.default_printer);
        formData.append("takeout_price", data.takeout_price);
        formData.append("effective_date", data.effective_date)
        formData.append("is_addon", data.is_addon)
        formData.append("frequency", data.frequency)
        formData.append("qty", data.qty)
        formData.append("reorder_point", data.reorder_point)
        formData.append("reorder_qty", data.reorder_qty)
        // formData.append("is_package", data.is_package)
        formData.append("is_dine_in", data.is_dine_in)
        formData.append("is_take_out", data.is_take_out)
        formData.append("is_delivery", data.is_delivery)
        formData.append("suspend_sale", data.suspend_sale)
        formData.append("quick_menu", data.quick_menu || 0)
        // formData.append("sold_by_weight", data.sold_by_weight)
        // formData.append("weight", data.weight)
        formData.append("open_price", data.open_price)
        formData.append("with_discount", data.with_discount)
        formData.append("is_addon", data.is_addon)
        formData.append("name", data.name)
        // formData.append("is_vatable", data.is_vatable)
        formData.append("price", data.price)
        formData.append("foodpanda_price", data.foodpanda_price)
        formData.append("grab_price", data.grab_price)
        formData.append("vat_in", data.vat_in);
        formData.append("is_vatable", data.is_vatable ? "1" : "0");
        formData.append("vat_ex", data.vat_ex);
        formData.append("vat_component", data.vat_component);
        formData.append("other_charges", data.other_charges)
        // formData.append("description", data.description)
        formData.append("requester", getUser())
        formData.append("token", getToken())
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "menus/update/" + data.id,
            formData 
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

//GET
export const deleteMenuManager = async (id) => {
    try {
        const params = new URLSearchParams();
        params.append('updated_by',getUser())
        params.append('token',getToken())

        const response = await putAPICall(
            process.env.REACT_APP_LINK + "menus/delete/" + id,
            params
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

//GET
export const inventory = async (id, qty) => {
    try {
        const params = new URLSearchParams();
        params.append('updated_by',getUser())
        params.append('token',getToken())
        params.append('qty', qty)

        const response = await putAPICall(
            process.env.REACT_APP_LINK + "menus/inventory/" + id,
            params
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};